import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { db } from '../../../FirebaseConfig'; // Adjust the path as needed
import { ref, set, push } from 'firebase/database';
import './app.css';

const CourseSpecificForm = () => {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        contactNumber: '',
        instituteName: '',
        url: window.location.href, // Capturing the current page URL
    });

    const [errors, setErrors] = useState({
        fullName: '',
        email: '',
        contactNumber: '',
        instituteName: '',
    });

    const validateEmail = (email) => {
        const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        return email.match(emailPattern) ? '' : 'Invalid email address.';
    };

    const validatePhone = (phone) => {
        const phonePattern = /^\d{10}$/;
        return phone.match(phonePattern) ? '' : 'Phone number must be 10 digits.';
    };

    const validateField = (name, value) => {
        let error = '';
        if (!value.trim()) {
            error = 'This field is required.';
        } else if (name === 'email') {
            error = validateEmail(value);
        } else if (name === 'contactNumber') {
            error = validatePhone(value);
        }
        setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        validateField(name, value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (Object.values(errors).some((error) => error) || Object.values(formData).some((value) => !value.trim())) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please fill in all fields correctly before submitting.',
            });
            return;
        }

        try {
            const contactRef = push(ref(db, 'courseFormData'));
            await set(contactRef, {
                ...formData,
                date: new Date().toLocaleString(),
            });

            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Your enrollment has been recorded!',
            });

            setFormData({
                fullName: '',
                email: '',
                contactNumber: '',
                instituteName: '',
                url: window.location.href, // Reset but keeps the current URL
            });
        } catch (error) {
            console.error('Error submitting course form:', error);
            Swal.fire({
                icon: 'error',
                title: 'Submission Error',
                text: 'Something went wrong. Please try again later.',
            });
        }
    };

    return (
        <>
            <form className='shadow p-1 mb-5 bg-body' onSubmit={handleSubmit} noValidate>
                <label className="justify-content-between form-label rcb_call d-flex">
                    <input
                        type="text"
                        name="fullName"
                        placeholder="Full Name"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                    />
                </label>
                {errors.fullName && <div className="error">{errors.fullName}</div>}

                <label className="justify-content-between form-label rcb_call d-flex">
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </label>
                {errors.email && <div className="error">{errors.email}</div>}

                <label className="justify-content-between form-label rcb_call d-flex">
                    <input
                        type="text"
                        name="contactNumber"
                        placeholder="Contact Number"
                        value={formData.contactNumber}
                        onChange={handleChange}
                        required
                    />
                </label>
                {errors.contactNumber && <div className="error">{errors.contactNumber}</div>}

                <label className="justify-content-between form-label rcb_call d-flex">
                    <input
                        type="text"
                        name="instituteName"
                        placeholder="Institute Name"
                        value={formData.instituteName}
                        onChange={handleChange}
                        required
                    />
                </label>
                {errors.instituteName && <div className="error">{errors.instituteName}</div>}

                <button type="submit" className="primary-btn2 text-uppercase enroll rounded-0">
                    Enroll in the Course
                </button>
            </form>
        </>
    );
};

export default CourseSpecificForm;
